/* eslint-disable @typescript-eslint/no-explicit-any */
import VideoJS from '@components/videojs/VideoJS';
import { ContentBlockFragment, LiveVideoFragment } from '@graphqlTypes/sitecore';
import { nonPageTracker } from '@src/adobe-launch/data-layer-provider';
import { TrackingEvent } from '@src/adobe-launch/types';
// import { NewDetailKolFragment } from '@src/common/kol-basic-data';
import { withBasePath } from '@src/common/path-convert';
import { convertArticleInfo } from '@src/hooks/tracker/use-article-tracker';
import { jsBridge } from '@src/utils/js-bridge';
import { removeflashUrl, withSitPath } from '@src/utils/util';
import React, { useEffect } from 'react';
import videojs from 'video.js';

/** 未来可能要区分mp4和直播的逻辑及播放器插件更换，暂时copy了份一样的组件使用。
 * 此组件仅用于处理直播播放逻辑
 */

export const LiveVideo = ({
    content,
    contentBlock,
}: {
    content: LiveVideoFragment;
    contentBlock: ContentBlockFragment;
}) => {
    // console.log('LiveVideocontent----', content);
    // const typeVal = (url: string) => {
    //     return !!url && url.includes('m3u8') ? 'application/x-mpegURL' : 'video/mp4';
    // };
    const playerRef = React.useRef(null);
    const videoJsOptions = {
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        //autoplay: content.videoAutoplay.boolValue,
        controls: true,
        disablePictureInPicture: true,
        responsive: true,
        fluid: true,
        fill: true,
        poster: content.liveStreamingPoster?.src || '',
        preload: 'metadata',
        sources: [
            {
                src: content.liveStreamingSource?.value,
                type: 'application/x-mpegURL',
                // type: typeVal(content.liveStreamingSource.value),
            },
        ],
    };

    const handlePlayerReady = (player: any) => {
        playerRef.current = player;
        // player.on('dispose', () => {
        //     player.dispose();
        // });
        const storedLiveID = sessionStorage.getItem('playerLiveId') ?? '[]';
        const getLiveID = Array.from(new Set(JSON.parse(storedLiveID)));
        getLiveID.push(player.id());
        sessionStorage.setItem('playerLiveId', JSON.stringify(Array.from(new Set(getLiveID))));

        const storedID = sessionStorage.getItem('playerId') ?? '[]';
        const getID = Array.from(new Set(JSON.parse(storedID)));
        getID.push(player.id());
        sessionStorage.setItem('playerId', JSON.stringify(Array.from(new Set(getID))));
    };

    const videoNativePlayer = () => {
        console.log('Live');

        nonPageTracker(
            {
                eventID: TrackingEvent.VideoPlay,
                videoURL: removeflashUrl(content.liveStreamingSource?.value ?? ''),
            },
            { article: convertArticleInfo(contentBlock) }
        );

        const getLivePlayerID = JSON.parse(sessionStorage.getItem('playerLiveId') ?? '[]');
        const getPlayerID = JSON.parse(sessionStorage.getItem('playerId') ?? '[]');
        //Stop all type native video, including MP4 and LiveStream
        getLivePlayerID?.length > 0 &&
            getLivePlayerID.forEach((i: string) => {
                if (document.getElementById(i)) {
                    const player = videojs(i);
                    // 暂停播放
                    player.pause();
                }
            });

        getPlayerID?.length > 0 &&
            getPlayerID.forEach((i: string) => {
                if (document.getElementById(i)) {
                    const player = videojs(i);
                    // 暂停播放
                    player.pause();
                }
            });

        jsBridge.appOpenNativePlayer(
            content.liveStreamingSource?.value ?? '',
            content.liveStreamingTitle?.value ?? '',
            content.videoNativePip?.boolValue ?? false
        );
    };

    useEffect(() => {
        return () => sessionStorage.removeItem('playerLiveId');
    }, []);

    return (
        <>
            {content.liveStreamingEnabled?.boolValue && (
                <div>
                    {content.videoNative?.boolValue ? (
                        <div
                            className='bg-[#000] min-h-[242px] md:min-h-[400px] lg:min-h-[514px] relative '
                            style={{
                                backgroundImage: `url(${withSitPath(
                                    content.liveStreamingPoster?.src ?? ''
                                )})`,
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                            }}
                            onClick={videoNativePlayer}
                        >
                            {/* <img
                                className='w-full h-full'
                                src={content.liveStreamingPoster?.src ?? ''}
                                alt=''
                            /> */}
                            <div className='absolute top-[50%] left-[50%] w-[86px] translate-x-[-50%] translate-y-[-50%]'>
                                <img src={withBasePath('/images/play.svg')} alt='' loading='lazy' />
                            </div>
                        </div>
                    ) : (
                        <VideoJS
                            options={videoJsOptions}
                            onReady={handlePlayerReady}
                            contentBlock={contentBlock}
                        />
                    )}
                </div>
            )}
        </>
    );
};

export default LiveVideo;
